module.exports = __webpack_public_path__ + "img/1.5f6e5b9d.jpeg";